import script from "./CanAddTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./CanAddTip.vue?vue&type=script&lang=ts&setup=true"

import "./CanAddTip.vue?vue&type=style&index=0&id=0ef8edce&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef8edce"]])

export default __exports__